/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Tier_Free_DescriptionInputs */

const en_pricing_tier_free_description = /** @type {(inputs: Pricing_Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An easy place to start`)
};

const es_pricing_tier_free_description = /** @type {(inputs: Pricing_Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un lugar fácil para empezar`)
};

/**
* | output |
* | --- |
* | "An easy place to start" |
*
* @param {Pricing_Tier_Free_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_tier_free_description = /** @type {((inputs?: Pricing_Tier_Free_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Tier_Free_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_tier_free_description(inputs)
	return en_pricing_tier_free_description(inputs)
});